<template>
  <div :class="['value-input-component-container', componentType]">
    <div class="input-component">
      <label v-if="showLabel">{{label}}
        <span class="field-info" v-if="fieldConfig.view.description && showTooltip" v-tooltip="fieldConfig.view.description"></span>
      </label>
      <component
        :is="componentType"
        :name="fieldConfig.view.name"
        :id="fieldConfig.id"
        :view="fieldConfig.view"
        :valueType="fieldConfig.valueType"
        v-model="value"
        :valueOptions="options"
        :readOnly="readOnly"
      ></component>
    </div>
  </div>
</template>

<script>
import { getValueTypeKey } from '@/utils/ConfigUtils'
import FormattedTextInput from './inputsTypes/FormattedTextInput'
import MultiSelectInput from './inputsTypes/MultiSelectInput'
import NumericInput from './inputsTypes/NumericInput'
import RangeInput from './inputsTypes/RangeInput'
import SliderInput from './inputsTypes/SliderInput'
import TextInput from './inputsTypes/TextInput'
import ToggleInput from './inputsTypes/ToggleInput'
import WaveformSelectInput from './inputsTypes/WaveformSelectInput'
import DistributionInput from './inputsTypes/DistributionInput'
import CheckboxInput from './inputsTypes/CheckboxInput.vue'

let componentTypeMap= {
  'formattedText': FormattedTextInput,
  'multiSelectInput': MultiSelectInput,
  'selectInput': MultiSelectInput,
  'distributionInput': DistributionInput,
  'numericInput': NumericInput,
  'rangeInput': RangeInput,
  'rangeSliderInput': SliderInput,
  'sliderInput': SliderInput,
  'textInput': TextInput,
  'toggleInput': ToggleInput,
  'checkboxInput': CheckboxInput,
  'namedXYSeriesInput': WaveformSelectInput
}

export default {
  name: 'InputContainer',
  props: {
    fieldConfig: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showUnits: {
      type: Boolean,
      default: false
    }
  },
  model:{
    prop: 'fieldConfig',
    event: 'change'
  },
  // data (){:showLabel="showLabel" 
  // },
  mounted () {
    // let val = {}
    //   if (this.fieldConfig.value && this.fieldConfig.value[this.keyValue]) {
    //     val = this.fieldConfig.value[this.keyValue]
    //   } else {
    //     val = this.fieldConfig.view['default' + this.keyValue[0].toUpperCase() + this.keyValue.slice(1) ]
    //   }
    //   // return val
    // this.value = val
    this.value = this.fieldConfig.value
  },
  computed: {
    value:{
      get(){
        return this.fieldConfig.value
      },
      set(value){
        this.fieldConfig.value = value
        this.$emit('change',this.fieldConfig.value)
      }
    },
    label() {
      if(this.showUnits && this.fieldConfig.view.units) return `${this.fieldConfig.view.name} (${this.fieldConfig.view.units})`
      else return this.fieldConfig.view.name
    },
    componentType () {
      let comp = ""
      switch (this.fieldConfig.view.inputType) {
        case 'field':
          if (this.fieldConfig.valueType === 'string') {
            comp = 'textInput'
          } else {
            comp = 'numericInput'
          }
          comp = 'textInput'
          break
        case 'formattedText':
          comp = 'formattedText'
          break
        case 'slider':
          comp = 'sliderInput'
          break
        case 'fieldRange':
          comp = 'rangeInput'
          break
        case 'sliderRange':
          comp = 'rangeSliderInput'
          break
        case 'toggle':
          comp = 'toggleInput'
          break
        case 'select':
          comp = 'selectInput'
          break
        case 'checkboxes':
          comp = 'multiSelectInput'
          break
        case 'checkbox':
          comp = 'checkboxInput'
          break
        case 'namedXYSeriesInput':
          comp = 'namedXYSeriesInput'
          break
        case 'distributionInput':
          comp = 'distributionInput'
          break
      }
      if(Object.keys(componentTypeMap).includes(comp)){
        return componentTypeMap[comp]
      } else {
        return null
      }
    },
    keyValue () {
      return getValueTypeKey(this.fieldConfig)
    },
    options () {
      // let key = this.keyValue.slice(0, this.keyValue.indexOf('Value') + 5) + 's'
      // return this.fieldConfig.view[key] ? this.fieldConfig.view[key] : []
      return this.fieldConfig.view.validate_items || []
    }
  },

  watch:{
    // value(){
    //   if(this.fieldConfig.value){ // ??????
    //     // this.fieldConfig.value[this.keyValue] = this.value
    //     this.fieldConfig.value = this.value
    //     this.$emit('change',this.fieldConfig.value)
    //   }
    // },
    // "fieldConfig.value"(){
    //   if(this.value !== this.fieldConfig.value) this.value = this.fieldConfig.value
    // }
  }
}
</script>

<style lang="stylus" scoped>
.value-input-component-container
  .input-component
    padding: 0 10px; //??
    label
      color: $shuttle-gray
      display: block
      m-font-size(12, 14)
      margin-bottom: 5px
      //text-transform: capitalize
      display flex
      align-items center
      .field-info
        display: inline-block
        m-icon('info', 14)
        margin-left 5px

    >>> .numeric-input,
    >>> .slider-input,
    >>> .range-input,
    >>> .text-input
      input
        border: 1px solid #fff
        border-radius: 4px
        box-shadow: 5px 5px 20px rgba($lynch, 0.25)
        // color: rgba($cloud-burst, 0.5)
        color: $cloud-burst //no?
        m-font-size(13, 16)
        min-height: 32px
        padding: 0 10px

        &:hover
          border-color: $heather

        &:focus
          border-color: $cloud-burst
          color: $cloud-burst
          outline: none
</style>